import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(partNumberStyles, {
    labelText: {
        css: css`
            display: none;
        `,
    },
    valueText: {
        forwardAs: "h2",
        size: 15,
        weight: TYPOGRAPHY.weight.medium,
        color: COLORS.secondary.light,
        css: css`
            margin-bottom: 0;
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: ["5px", null, "15px", null, null], properties: ["margin-bottom"] },
                        { values: ["block", null, "inline", null, null], properties: ["display"] },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
});
